/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { MessageResponseDto } from './MessageResponseDto';
import {
    MessageResponseDtoFromJSON,
    MessageResponseDtoFromJSONTyped,
    MessageResponseDtoToJSON,
    MessageResponseDtoToJSONTyped,
} from './MessageResponseDto';

/**
 * 
 * @export
 * @interface PaginatedMessagesResponseDto
 */
export interface PaginatedMessagesResponseDto {
    /**
     * List of messages
     * @type {Array<MessageResponseDto>}
     * @memberof PaginatedMessagesResponseDto
     */
    data: Array<MessageResponseDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof PaginatedMessagesResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the PaginatedMessagesResponseDto interface.
 */
export function instanceOfPaginatedMessagesResponseDto(value: object): value is PaginatedMessagesResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function PaginatedMessagesResponseDtoFromJSON(json: any): PaginatedMessagesResponseDto {
    return PaginatedMessagesResponseDtoFromJSONTyped(json, false);
}

export function PaginatedMessagesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedMessagesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MessageResponseDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function PaginatedMessagesResponseDtoToJSON(json: any): PaginatedMessagesResponseDto {
    return PaginatedMessagesResponseDtoToJSONTyped(json, false);
}

export function PaginatedMessagesResponseDtoToJSONTyped(value?: PaginatedMessagesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(MessageResponseDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

